import { render, staticRenderFns } from "./TreatmentForm.vue?vue&type=template&id=595a4c9b"
import script from "./TreatmentForm.vue?vue&type=script&lang=js"
export * from "./TreatmentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports